<template>
  <f7-app v-bind="f7params">
    <!-- Left panel with cover effect when hidden -->
    <f7-panel left cover theme-light :visible-breakpoint="960" ref="leftMenuPanel" v-if="isLoggedIn">
      <f7-view>
        <f7-page>
          <f7-navbar title="Private Gym"></f7-navbar>
          <f7-block-title>
            Trainen
          </f7-block-title>
          <f7-list class="list-strong list-outline list-dividers">
            <f7-list-item panel-close="left" title="Jouw trainingen" view=".view-main"
                          link="/trainingen"></f7-list-item>
                   <f7-list-item title="Techniek training" link="/videos/workouts" view=".view-main"></f7-list-item>
          </f7-list>


          <f7-block-title>
            Reserveren
          </f7-block-title>
          <f7-list class="list-strong list-outline list-dividers">
            <f7-list-item panel-close="left" title="Training inplannen" view=".view-main"
                          link="/account/calendar"></f7-list-item>
            <f7-list-item panel-close="left" title="Reserveringen" view=".view-main"
                          link="/account/reserveringen"></f7-list-item>
          </f7-list>


          <template v-if="current_user">
            <f7-block-title>
              Account
            </f7-block-title>
            <f7-list class="list-strong list-outline list-dividers">
              <f7-list-item panel-close="left" title="Instellingen" view=".view-main"
                            :link="'/users/' + current_user.id"></f7-list-item>
              <!--
                40-09. Directly under Instellingen because it is the same data
                under a name a member would actually look for: 40-06 put a
                payment push on a real handset and the owner's first question
                was "is there even a page?". There was, and it was called
                Instellingen.

                The "Betaling" entry in the Algemeen block below is NOT renamed
                and NOT removed -- owner decision, 2026-08-20: the menu reads
                Abonnement and Betaling. They are different screens; that one is
                the till.
              -->
              <f7-list-item panel-close="left" title="Abonnement" view=".view-main"
                            link="/account/abonnement"></f7-list-item>
              <f7-list-item panel-close="left" title="Notificaties" view=".view-main"
                            link="/account/notificaties"></f7-list-item>
            </f7-list>
          </template>

          <f7-block-title>
            Algemeen
          </f7-block-title>
          <f7-list class="list-strong list-outline list-dividers">
            <!--        <f7-list-item title="Instellingen" link="#"></f7-list-item>-->
            <f7-list-item title="Feedback" link="#" @click="showFeedbackSheet = true"></f7-list-item>
            <f7-list-item panel-close="left" title="Betaling" view=".view-main" link="/account/payments"></f7-list-item>
          </f7-list>

          <!--
            THESE ENTRIES ARE UX, NOT AUTHORIZATION. Hiding a menu row hides
            nothing: the routes exist whether or not it renders, `vuex-persist`
            writes `current_user` straight to localStorage, and the API's own
            `admin` / `super_admin` middleware is the only real control. They are
            here so nobody is shown a screen whose every request would 403.

            The wrapper is `is_admin` OR `is_super_admin`, because
            `is_super_admin` is a SEPARATE boolean (Phase 36), not a level above
            `is_admin` — a super admin who is not also a plain admin would
            otherwise never see this block, and so never reach the news screens.
          -->
          <template v-if="current_user.is_admin || current_user.is_super_admin === true">
            <f7-block-title>
              Admin
            </f7-block-title>
            <f7-list class="list-strong list-outline list-dividers">
              <!--
                TRUTHY on both of these, unchanged: `CurrentUserResource` sends
                `is_admin` as the raw integer 0/1 and `requireAdmin` depends on
                that. They keep their own condition now that the wrapper above is
                wider.
              -->
              <f7-list-item panel-close="left" title="Leden" view=".view-main" link="/admin/users"
                            v-if="current_user.is_admin"></f7-list-item>
              <f7-list-item panel-close="left" title="@Gym" view=".view-main"
                            v-if="current_user.is_admin"
                            :link="'/admin/gyms/'+current_user.gym.id+'/current-users'"></f7-list-item>
              <!--
                STRICT `=== true`, matching `requireSuperAdmin` in js/guards.js.
                `is_super_admin` is a real JSON boolean, so an integer 1 can only
                come from a hand-edited store or a contract regression — and
                showing this row to either would put a menu entry in front of
                somebody every one of whose requests the API will reject.
              -->
              <f7-list-item panel-close="left" title="Nieuws" view=".view-main" link="/admin/news"
                            v-if="current_user.is_super_admin === true"></f7-list-item>
              <!--
                B1 (D-44-13). Same strict condition as the row above; the
                docblock covers all three.

                It points at the HISTORY LIST, not at the composer. The delivery
                outcome is written back after the send, by which time the
                composer has closed, so only a list can show it.

                THIS ROW IS NOT AUTHORIZATION. It is the first of D-44-13's
                three layers and the first of the two that are UX: the row, then
                `beforeEnter: requireSuperAdmin`, then the API's
                `EnsureIsSuperAdmin` — and only the last is security.
              -->
              <f7-list-item panel-close="left" title="Pushberichten" view=".view-main"
                            link="/admin/broadcasts"
                            v-if="current_user.is_super_admin === true"></f7-list-item>
              <!-- Same strict condition as the rows above; the docblock covers all three. -->
              <f7-list-item panel-close="left" title="Bevestigingsmomenten" view=".view-main"
                            link="/admin/booking-stages"
                            v-if="current_user.is_super_admin === true"></f7-list-item>
            </f7-list>
          </template>
          <f7-button
              v-if="impersonating"
              color="orange"
              class="mx-3 py-4"
              raised
              fill
              @click="stopImpersonate"
          >
            Log uit als lid
          </f7-button>
          <f7-list class="list-strong list-outline list-dividers">
            <f7-list-item title="Logout" link="#" @click="logout"></f7-list-item>
          </f7-list>

          <f7-block-title class="panel-version">
            <small>v{{ appVersion }}</small>
          </f7-block-title>
        </f7-page>
      </f7-view>
    </f7-panel>

    <!-- Your main view, should have "view-main" class -->
    <f7-view main class="safe-areas"
             :url="current_route_browser"
             :browser-history="isBrowser"
             :routes-before-enter="routeChanged"
    ></f7-view>

    <!-- Login-time permission explainer (owner decision 2026-08-20). Opened only
         by offerPermissionPromptAtLogin(), once per device. -->
    <notification-permission-sheet
        :show="showLoginPermissionSheet"
        title="Zet push notificaties aan"
        body="Je krijgt zo een melding om push notificaties aan te zetten. Dit is nodig voor het bevestigen van de reservering van je eiland. Zonder tijdige bevestiging kan het zijn dat je reservering geannuleerd wordt."
        @closed="showLoginPermissionSheet = false"
    ></notification-permission-sheet>

    <feedback-sheet-modal
        title="Melding"
        :show="showFeedbackSheet"
        @closed="showFeedbackSheet = false"
        header_text="Heb je tips? Feedback? Verbeterpunten voor de gym? Wensen? Of een dikke pluim? Laat hier je feedback achter. Samen maken we er een toffe gym ervaring van!"
    ></feedback-sheet-modal>
  </f7-app>
</template>
<script>
import {ref, onMounted} from 'vue';
import {f7, f7ready} from 'framework7-vue';

import {getDevice} from 'framework7/lite-bundle';
import capacitorApp from '../js/capacitor-app.js';
import routes from '../js/routes.js';
import {startPushSession, consumeNotificationNavigation, offerPermissionPromptAtLogin} from '../js/push-session.js';
import store from '../js/store';
import FeedbackSheetModal from "../components/general/FeedbackSheetModal.vue";
import NotificationPermissionSheet from "../components/general/NotificationPermissionSheet.vue";

import '@capacitor/core';
import Home from "../pages/home.vue";

export default {
  components: {Home, FeedbackSheetModal, NotificationPermissionSheet},
  data() {
    return {
      showFeedbackSheet: false,
      showLoginPermissionSheet: false,
      f7Ready: false,
    }
  },
  setup() {
    const device = getDevice();
    // Framework7 Parameters
    const f7params = {
      name: 'Private Gym', // App name
      theme: 'ios', // Automatic theme detection


      // App store
      store: store,
      // App routes
      routes: routes,

      // Input settings
      input: {
        scrollIntoViewOnFocus: device.capacitor,
        scrollIntoViewCentered: device.capacitor,
      },
      // Capacitor Statusbar settings
      statusbar: {
        enabled: false,
        // iosOverlaysWebView: true,
        // androidOverlaysWebView: false,
      },
    };

    onMounted(() => {
      f7ready(() => {
        // Init capacitor APIs (see capacitor-app.js)
        if (device.capacitor) {
          capacitorApp.init(f7);
        }
        // Call F7 APIs here
      });
    });

    return {
      f7params,
    }
  },

  computed: {
    notifications() {
      return this.$store.state.notifications.data;
    },
    appVersion() {
      return import.meta.env.PG_APP_VERSION;
    },
    show_loader() {
      return this.$store.state.app.show_loader;
    },
    isLoggedIn() {
      return this.$store.getters['current_user/isLoggedIn'];
    },
    isBrowser() {
      return this.$store.getters['app/is_browser'];
    },
    current_user() {
      return this.$store.state.current_user.data;
    },
    impersonating() {
      return !!this.$store.state.current_user.origin_user;
    },
    current_user_has_token() {
      return this.$store.getters['current_user/token'].length > 0;
    },
    // PUSH-07. A tapped notification writes its payload here and this component
    // is the only consumer; see consumePushNavigation() below.
    pending_navigation() {
      return this.$store.state.push.pending_navigation;
    },
    current_route() {
      if (this.f7Ready) {
        return f7.views.main.router.currentRoute.url;
      }
    },
    current_route_browser() {
      return window.location.pathname + window.location.search;
    }
  },
  mounted() {
    let vm = this;
    console.log('app.vue mounted()')
    console.log('isBrowser', this.isBrowser)
    console.log('f7.device', f7.device)
    f7ready(() => {
      vm.f7Ready = true;
      // Inside f7ready, not before it: registration can deliver a queued tap
      // immediately, and that tap needs a router to land on. Fired and left to
      // resolve on its own -- startPushSession never throws and the shell must
      // not wait on a network round trip. It no-ops unless a member is logged in
      // and the OS permission is already granted, so it can never prompt here.
      // The explainer that CAN lead to the prompt is offered afterwards.
      startPushSession(vm.$store).then(() => vm.offerLoginPermissionSheet());
    });
    this.$store.commit('api/set_api_url', import.meta.env.PG_API_ROOT_URL);
  },
  methods: {
    /**
     * Owner decision 2026-08-20: ask at login, through the explainer, once per
     * device. The decision and the once-only mark live in push-session.js so
     * they are unit-tested; this only flips the sheet.
     */
    offerLoginPermissionSheet() {
      if (!offerPermissionPromptAtLogin(this.$store)) {
        return;
      }
      // Same deferral calendar.vue needs to avoid an f7 sheet render glitch.
      setTimeout(() => { this.showLoginPermissionSheet = true; }, 500);
    },
    logout() {
      f7.dialog.confirm('Weet je het zeker?', 'Uitloggen', () => {
        const panel = f7.panel.get('left');
        if (panel && panel.opened) {
          panel.close(true);
          panel.once('closed', () => {
            this.$store.dispatch('current_user/logout').then(() => {
              f7.views.main.router.navigate('/auth/login');
            });
          });
        } else {
          this.$store.dispatch('current_user/logout').then(() => {
            f7.views.main.router.navigate('/auth/login');
          });
        }
      }, null)
    },
    stopImpersonate() {
      let vm = this;
      vm.$store.dispatch('current_user/stop_impersonate').then(() => {
        vm.$store.dispatch("notifications/addSuccessNotification", {
          message: "Stopped impersonating successfully",
        });
      })
    },
    /**
     * PUSH-07. Hand a tapped notification's destination to the main router.
     *
     * Both the router and the pending value can be absent, and they can arrive
     * in either order -- a tap that cold-started the app is delivered during
     * boot. So this is called from two watchers and is written to be safe to run
     * at any moment: consumeNotificationNavigation() refuses to consume without
     * a router, which leaves the destination in the store for the f7Ready
     * watcher to pick up, and it consumes exactly once so the two callers cannot
     * double-navigate.
     */
    consumePushNavigation() {
      if (this.f7Ready === false) {
        return;
      }
      let router = f7.views && f7.views.main ? f7.views.main.router : null;
      consumeNotificationNavigation(this.$store, router);
    },
    routeChanged({resolve, reject}) {
      if (this.f7Ready) {
        if (this.$refs.leftMenuPanel !== null && typeof this.$refs.leftMenuPanel !== 'undefined') {
          setTimeout(() => {
            f7.panel.close(this.$refs.leftMenuPanel.$el);
          }, 50)
        }
      }
      resolve();
    }
  },
  watch: {
    notifications: {
      deep: true,
      handler(notifications) {
        let new_notification = notifications[0];
        let toast = f7.toast.create({
          icon: new_notification.icon,
          text: new_notification.message,
          cssClass: new_notification.cssClass,
          closeButtonColor: new_notification.closeButtonColor,
          closeButton: true,
          destroyOnClose: true,
          closeTimeout: new_notification.hide_after,
          position: new_notification.position,
        }).open();
      }
    },
    show_loader(value) {
      if (this.f7Ready === false) {
        return;
      }
      if (value) {
        f7.preloader.show();
      } else {
        f7.preloader.hide();
      }
    },
    isLoggedIn(value) {
      if (value) {
        this.$store.dispatch('broadcasting/connect', {});
        // A member who logs in mid-session was anonymous when mounted() ran, so
        // the ignition there refused. This is the second call site; the function
        // is idempotent, so the two overlapping is harmless.
        startPushSession(this.$store).then(() => this.offerLoginPermissionSheet());
      }
    },
    pending_navigation(value) {
      if (!value) {
        return;
      }
      this.consumePushNavigation();
    },
    f7Ready(value) {
      if (value) {
        // A tap that cold-started the app can land before Framework7 has built
        // its views. In that window consumeNotificationNavigation() deliberately
        // does NOT consume, so the destination is still sitting in the store and
        // this is what finally spends it.
        this.consumePushNavigation();
      }
    },
    current_user_has_token: {
      immediate: true,
      handler(current_user_has_token) {
        if (!current_user_has_token) {
          f7ready(() => {
            setTimeout(() => {
              // Only redirect if the route does not contain '/auth'
              if (!this.current_route.includes('/auth')) {
                f7.views.main.router.navigate('/auth/login');
              }
            }, 50) // Needed or it will error out, can be 1, but 50 just in case
          });
        }
      }
    },
  },
}
</script>
<style>
/*.toast.toast-bottom.toast-horizontal-left {*/
/*  height: 45px;*/
/*}*/
</style>
